import { Asset } from "./asset";

export type AdPlacements =
  | "skyscraper"
  | "header"
  | "footer"
  | "overlay_primary"
  | "overlay_secondary"
  | "carousel"
  | "banner";

export type Placements = {
  [key in AdPlacements]: AdvertDetails;
};

export type Advert = {
  path: string;
  placements: Placements;
};

export type InternalAd = {
  campaign_id: number;
  asset: Asset;
  link_url: string;
};

export type IframeAd = {
  campaign_id: number;
  iframe: string;
};

export type AdvertDetails = InternalAd | IframeAd;

// type narrowing functions
export function isIframeAd(ad: AdvertDetails): ad is IframeAd {
  return (ad as IframeAd).iframe !== undefined;
}

export function isInsAd(ad: AdvertDetails): boolean {
  return isIframeAd(ad) && ad?.iframe?.startsWith("<ins");
}

export function isInternalAd(ad: AdvertDetails): ad is InternalAd {
  return (ad as InternalAd).asset !== undefined;
}
